// extracted by mini-css-extract-plugin
module.exports = {"hideSmallScreen":"eQ","showOnlySmallScreen":"fQ","expired":"gQ","paymentTypeIcon":"hQ","bordered":"iQ","forceWrap":"jQ"};